<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-card>
        <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
          <span>IPCR of {{ data && data.name }}</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeD()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text style="max-height: 900px" class="my-4">
          <v-card>
            <v-row>
              <v-col cols="8" class="flex-items mt-2">
                <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
                  <v-tab
                    v-for="tab in tabList"
                    :key="tab.id"
                    @change="changeTab(tab)"
                    >{{ tab.name }}</v-tab
                  >
                </v-tabs>
              </v-col>
              <v-col cols="12" class="pt-2 px-4" v-show="tab != 5">
                <table id="ipcrTable" v-if="tab != 4">
                  <tr>
                    <td
                      colspan="2"
                      style="width: 20%"
                      rowspan="2"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Major Final Output(MFO)
                    </td>
                    <td
                      style="width: 20%"
                      rowspan="2"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Success Indicators<br />Target + Measure
                    </td>
                    <td
                      style="width: 20%"
                      rowspan="2"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Actual Accomplishments
                    </td>
                    <td
                      style="width: 20%"
                      colspan="4"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Rating
                    </td>
                    <td
                      style="width: 20%"
                      rowspan="2"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Remarks
                    </td>
                    <td
                      v-if="isEvaluating"
                      style="width: 20%; padding: 10px"
                      rowspan="2"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Action
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="width: 5%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      E
                    </td>
                    <td
                      style="width: 5%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Q
                    </td>
                    <td
                      style="width: 5%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      T
                    </td>
                    <td
                      style="width: 5%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      A
                    </td>
                  </tr>
                  <tbody
                    v-if="
                      ipcrToView && ipcrToView.func_type != 'Support Function'
                    "
                  >
                    <tr>
                      <td
                        :colspan="!isEvaluating ? 9 : 9 + 1"
                        class="text-subtitle-1 text-justify font-weight-bold"
                        style="text-indent: 10px"
                      >
                        {{ ipcrToView.func_type }}

                        ({{
                          ipcrToView && ipcrToView.func_type == "Core Function"
                            ? ipcrData[1].data.length > 0
                              ? "60%"
                              : "90%"
                            : ipcrToView &&
                              ipcrToView.func_type == "Strategic Priority"
                            ? ipcrData[1].data.length > 0
                              ? "30%"
                              : "0%"
                            : "10%"
                        }})
                      </td>
                    </tr>

                    <tr v-for="(item, i) in ipcrToView.data" :key="i">
                      <td class="text-caption pa-1" align="center">
                        {{
                          ipcrToView && ipcrToView.func_type == "Core Function"
                            ? "CF" + (i + 1)
                            : ipcrToView &&
                              ipcrToView.func_type == "Strategic Priority"
                            ? "SP" + (i + 1)
                            : "SF" + (i + 1)
                        }}
                      </td>
                      <td class="text-caption pa-1" align="left">
                        {{ item.mfo }}
                      </td>
                      <td class="text-caption pa-1" align="left">
                        {{ item.success_indicator }}
                      </td>
                      <td class="text-caption pa-1" align="left">
                        {{ item.actual_accomplishment }}
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.e_avg }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{
                              formatNumberValue(item.evaluation.efficiency, 2)
                            }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ formatNumberValue(item.review.efficiency, 2) }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ formatNumberValue(item.q_avg, 2) }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ formatNumberValue(item.evaluation.quality, 2) }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ formatNumberValue(item.review.quality, 2) }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ formatNumberValue(item.t_avg, 2) }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{
                              formatNumberValue(item.evaluation.timeliness, 2)
                            }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ formatNumberValue(item.review.timeliness, 2) }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ formatNumberValue(item.a_avg, 2) }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ formatNumberValue(computeAvg(item), 2) }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ formatNumberValue(computeReviewAvg(item), 2) }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.remarks }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ item.evaluation.remarks }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ item.review.remarks }}
                          </div>
                        </div>
                      </td>
                      <td
                        v-if="isEvaluating"
                        class="text-caption"
                        style="padding: 10px"
                        align="center"
                      >
                        <v-btn
                          x-small
                          color="warning"
                          @click="add_evaluation(item, i)"
                          class="white-text"
                          >{{ getAddEvaluationBtnText(item) }} evaluation</v-btn
                        >
                      </td>
                    </tr>

                    <tr>
                      <td colspan="7" align="right" class="text-caption pa-2">
                        Total {{ ipcrToView && ipcrToView.func_type }}
                      </td>
                      <td align="center" class="text-caption">
                        <div>
                          <div>{{ ipcrToView && ipcrToView.total }}</div>
                          <div class="green white--text">
                            {{
                              formatNumberValue(
                                tab == 1
                                  ? computeEvaluationCFTotal
                                  : tab == 2
                                  ? computeEvaluationSPTotal
                                  : "",
                                2
                              )
                            }}
                          </div>
                          <div class="light-blue darken-1 white--text">
                            {{
                              formatNumberValue(
                                tab == 1
                                  ? computeReviewCFTotal
                                  : tab == 2
                                  ? computeReviewSPTotal
                                  : "",
                                2
                              )
                            }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption"></td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td
                        :colspan="!isEvaluating ? 9 : 10"
                        class="text-subtitle-1 text-justify font-weight-bold"
                        style="text-indent: 10px"
                      >
                        {{ ipcrToView && ipcrToView.func_type }} (10%)
                      </td>
                    </tr>
                    <!-- sf1 -->
                    <tr
                      v-for="(item, i) in ipcrToView &&
                      ipcrToView.data.sf1.data"
                      :key="i.id"
                    >
                      <td
                        v-if="i == 0"
                        :rowspan="ipcrToView && ipcrToView.data.sf1.data.length"
                        class="text-caption pa-1"
                        align="center"
                      >
                        SF1
                      </td>
                      <td
                        v-if="i == 0"
                        :rowspan="ipcrToView.data.sf1.data.length"
                        class="text-caption pa-1"
                        align="left"
                      >
                        {{ item.mfo }}
                      </td>
                      <td class="text-caption pa-1" align="left">
                        {{ item.success_indicator }}
                      </td>
                      <td class="text-caption" align="left">
                        {{ item.actual_accomplishment }}
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.e_avg }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{
                              formatNumberValue(item.evaluation.efficiency, 2)
                            }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ formatNumberValue(item.review.efficiency, 2) }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.q_avg }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ formatNumberValue(item.evaluation.quality, 2) }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ formatNumberValue(item.review.quality, 2) }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.t_avg }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{
                              formatNumberValue(item.evaluation.timeliness, 2)
                            }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ formatNumberValue(item.review.timeliness, 2) }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.a_avg }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ formatNumberValue(computeAvg(item), 2) }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ formatNumberValue(computeReviewAvg(item), 2) }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.remarks }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ item.evaluation.remarks }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ item.review.remarks }}
                          </div>
                        </div>
                      </td>
                      <td
                        v-if="isEvaluating"
                        class="text-caption"
                        style="padding: 10px"
                        align="center"
                      >
                        <v-btn
                          x-small
                          color="warning"
                          @click="add_evaluation(item, i, 'sf1')"
                          class="white-text"
                          >{{ getAddEvaluationBtnText(item) }} evaluation</v-btn
                        >
                      </td>
                    </tr>

                    <tr>
                      <td colspan="4" align="right" class="text-caption pa-2">
                        Total
                        {{ ipcrToView && ipcrToView.data.sf1.data[0].mfo }} /
                        {{ getSF1Len + " X " }}
                        {{
                          ipcrToView && ipcrToView.data.sf2.data.length == 0
                            ? "100%"
                            : "60%"
                        }}
                      </td>
                      <td colspan="4" align="center" class="text-caption">
                        <div>
                          <div>
                            {{ ipcrToView && ipcrToView.data.sf1.sftotal }}
                          </div>
                          <div class="green white--text">
                            {{ formatNumberValue(getSFTotalEvaluation.sf1, 2) }}
                          </div>
                          <div
                            v-if="moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ formatNumberValue(getSFTotalReview.sf1, 2) }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption"></td>
                      <td class="text-caption" v-if="isEvaluating"></td>
                    </tr>

                    <!-- sf2 -->
                    <tr
                      v-for="(item, i) in ipcrToView &&
                      ipcrToView.data.sf2.data"
                      :key="i.id"
                    >
                      <td
                        v-if="i == 0"
                        :rowspan="ipcrToView && ipcrToView.data.sf2.data.length"
                        class="text-caption pa-1"
                        align="center"
                      >
                        SF2
                      </td>
                      <td
                        v-if="i == 0"
                        :rowspan="ipcrToView && ipcrToView.data.sf2.data.length"
                        class="text-caption pa-1"
                        align="left"
                      >
                        {{ item.mfo }}
                      </td>
                      <td class="text-caption pa-1" align="left">
                        {{ item.success_indicator }}
                      </td>
                      <td
                        class="text-caption preserve-whitespace pa-2"
                        align="left"
                      >
                        {{ item.actual_accomplishment }}
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.e_avg }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{
                              formatNumberValue(item.evaluation.efficiency, 2)
                            }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ formatNumberValue(item.review.efficiency) }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.q_avg }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ formatNumberValue(item.evaluation.quality, 2) }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ formatNumberValue(item.review.quality, 2) }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.t_avg }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{
                              formatNumberValue(item.evaluation.timeliness, 2)
                            }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ formatNumberValue(item.review.timeliness) }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.a_avg }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ formatNumberValue(computeAvg(item), 2) }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ formatNumberValue(getSFTotalReview.sf2, 2) }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.remarks }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ item.evaluation.remarks }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ item.review.remarks }}
                          </div>
                        </div>
                      </td>
                      <td
                        v-if="isEvaluating"
                        class="text-caption"
                        style="padding: 10px"
                        align="center"
                      >
                        <v-btn
                          x-small
                          color="warning"
                          @click="add_evaluation(item, i, 'sf2')"
                          class="white-text"
                          >{{ getAddEvaluationBtnText(item) }} evaluation</v-btn
                        >
                      </td>
                    </tr>

                    <tr
                      v-if="ipcrToView && ipcrToView.data.sf2.data.length > 0"
                    >
                      <td colspan="4" align="right" class="text-caption pa-2">
                        Total
                        {{ ipcrToView && ipcrToView.data.sf2.data[0].mfo }}
                        {{
                          ipcrToView && ipcrToView.data.sf2.data.length > 1
                            ? " / " + ipcrToView.data.sf2.data.length + " X 40%"
                            : " X 40%"
                        }}
                      </td>
                      <td colspan="4" align="center" class="text-caption">
                        <div>
                          <div>
                            {{ ipcrToView && ipcrToView.data.sf2.sftotal }}
                          </div>
                          <div class="green white--text">
                            {{ formatNumberValue(getSFTotalEvaluation.sf2, 2) }}
                          </div>
                          <div
                            v-if="moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ formatNumberValue(getSFTotalReview.sf2, 2) }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption"></td>
                    </tr>

                    <tr>
                      <td align="center" colspan="7" class="pa-1 text-caption">
                        Total {{ ipcrToView && ipcrToView.func_type }}
                      </td>
                      <td align="center" class="text-caption">
                        <div>
                          <div>{{ ipcrToView && ipcrToView.total }}</div>
                          <div class="green white--text">
                            {{
                              formatNumberValue(
                                parseFloat(
                                  formatNumberValue(getSFTotalEvaluation.sf1, 2)
                                ) +
                                  parseFloat(
                                    formatNumberValue(
                                      getSFTotalEvaluation.sf2,
                                      2
                                    )
                                  ),
                                2
                              )
                            }}
                          </div>
                          <div class="light-blue darken-1 white--text">
                            {{
                              formatNumberValue(
                                parseFloat(
                                  formatNumberValue(getSFTotalReview.sf1, 2)
                                ) +
                                  parseFloat(
                                    formatNumberValue(getSFTotalReview.sf2, 2)
                                  ),
                                2
                              )
                            }}
                          </div>
                        </div>
                      </td>
                      <td align="center" class="text-caption"></td>
                    </tr>
                  </tbody>
                </table>
                <table v-else id="categoryTable">
                  <tr>
                    <td
                      style="width: 20%"
                      class="font-weight-bold text-caption pa-1"
                      align="center"
                    >
                      Category
                    </td>
                    <td
                      style="width: 20%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Total
                    </td>
                    <td
                      style="width: 20%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Number of MFO's
                    </td>
                    <td
                      style="width: 20%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Percentage(%)
                    </td>
                    <td
                      style="width: 20%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      General Average
                    </td>
                  </tr>
                  <tr v-for="(item, i) in ipcrData" :key="i">
                    <td
                      align="left"
                      style="text-indent: 10px"
                      class="text-caption pa-1"
                    >
                      {{ item.func_type }}
                    </td>
                    <td align="center" class="text-caption pa-1">
                      <div>
                        <div>{{ item.total }}</div>
                        <div class="green white--text">
                          {{
                            formatNumberValue(
                              i == 0
                                ? computeEvaluationCFTotal
                                : i == 1
                                ? computeEvaluationSPTotal
                                : parseFloat(
                                    formatNumberValue(
                                      getSFTotalEvaluation.sf1,
                                      2
                                    )
                                  ) +
                                  parseFloat(
                                    formatNumberValue(
                                      getSFTotalEvaluation.sf2,
                                      2
                                    )
                                  ),
                              2
                            )
                          }}
                        </div>
                        <div
                          v-if="moduleFrom == 'Review'"
                          class="light-blue darken-1 white--text"
                        >
                          {{
                            formatNumberValue(
                              i == 0
                                ? computeReviewCFTotal
                                : i == 1
                                ? computeReviewSPTotal
                                : parseFloat(
                                    formatNumberValue(getSFTotalReview.sf1, 2)
                                  ) +
                                  parseFloat(
                                    formatNumberValue(getSFTotalReview.sf2, 2)
                                  ),
                              2
                            )
                          }}
                        </div>
                      </div>
                    </td>
                    <td align="center" class="text-caption">
                      {{
                        item.func_type != "Support Function"
                          ? item.data.length
                          : ""
                      }}
                    </td>
                    <td align="center" class="text-caption">
                      {{
                        item.func_type != "Support Function"
                          ? item.func_type == "Core Function"
                            ? ipcrData[1].data.length > 0
                              ? "60%"
                              : "90%"
                            : ipcrData[1].data.length > 0
                            ? "30%"
                            : "0%"
                          : "10%"
                      }}
                    </td>
                    <td align="center" class="text-caption pa-1">
                      <div>
                        <div>
                          {{
                            computeGeneralAve(
                              item,
                              item.func_type != "Support Function"
                                ? item.func_type == "Core Function"
                                  ? ipcrData[1].data.length > 0
                                    ? 0.6
                                    : 0.9
                                  : ipcrData[1].data.length > 0
                                  ? 0.3
                                  : 0
                                : 0.1
                            )
                          }}
                        </div>
                        <div class="green white--text">
                          {{
                            i == 0
                              ? formatNumberValue(getEvaluationGenAvg.cfAvg, 2)
                              : i == 1
                              ? formatNumberValue(getEvaluationGenAvg.spAvg, 2)
                              : i == 2
                              ? formatNumberValue(getEvaluationGenAvg.sfAvg, 2)
                              : ""
                          }}
                        </div>
                        <div
                          v-if="moduleFrom == 'Review'"
                          class="light-blue darken-1 white--text"
                        >
                          {{
                            i == 0
                              ? formatNumberValue(getReviewGenAvg.cfAvg, 2)
                              : i == 1
                              ? formatNumberValue(getReviewGenAvg.spAvg, 2)
                              : i == 2
                              ? formatNumberValue(getReviewGenAvg.sfAvg, 2)
                              : ""
                          }}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td
                      colspan="4"
                      align="left"
                      style="text-indent: 10px"
                      class="text-caption pa-1"
                    >
                      Total/Final Overall Rating
                    </td>
                    <td align="center" class="text-caption pa-1">
                      <div>
                        <div>{{ getOverAllrating() }}</div>
                        <div class="green white--text">
                          {{ getFinalAvgRating.evaluation.total }}
                        </div>
                        <div
                          v-if="moduleFrom == 'Review'"
                          class="light-blue darken-1 white--text"
                        >
                          {{ getFinalAvgRating.review.total }}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td
                      colspan="4"
                      align="left"
                      style="text-indent: 10px"
                      class="text-caption pa-1"
                    >
                      Final Average Rating
                    </td>
                    <td align="center" class="text-caption pa-1">
                      <div class="green white--text">
                        {{ getFinalAvgRating.evaluation.adjectival_rating }}
                      </div>
                      <div
                        v-if="moduleFrom == 'Review'"
                        class="light-blue darken-1 white--text"
                      >
                        {{ getFinalAvgRating.review.adjectival_rating }}
                      </div>
                    </td>
                  </tr>
                </table>
              </v-col>
              <v-col cols="12" class="pt-2 px-4" v-show="tab == 5">
                <v-data-table
                  :headers="headers"
                  :items="evidenceList"
                  :items-per-page="-1"
                  hide-default-footer
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn
                      v-if="data && data.isFaculty == 0"
                      elevation="2"
                      color="#17C800"
                      class="white--text my-1"
                      x-small
                      block
                      @click="viewMPOR(item)"
                    >
                      <v-icon size="14">mdi-eye</v-icon>
                      View MPOR</v-btn
                    >
                    <v-btn
                      v-if="data && data.isFaculty == 0"
                      elevation="2"
                      block
                      color="primary"
                      class="white--text my-1"
                      x-small
                      @click="viewAttachment(item)"
                    >
                      <v-icon size="14">mdi-eye</v-icon>
                      View Attachment</v-btn
                    >
                    <v-btn
                      v-if="data && data.isFaculty == 1"
                      elevation="2"
                      block
                      color="primary"
                      class="white--text my-1"
                      x-small
                      @click="viewLink(item)"
                    >
                      <v-icon size="14">mdi-eye</v-icon>
                      View Attachment</v-btn
                    >
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
        <!-- <v-divider></v-divider> -->
        <v-card-actions class="pa-5" v-if="tbl_tab == 1">
          <v-btn
            color="#519043"
            class="white--text"
            @click="bottom_actions = !bottom_actions"
          >
            Actions
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-bottom-sheet v-model="bottom_actions" v-if="tbl_tab == 1">
      <v-card
        class="text-center"
        height="100"
        v-if="moduleFrom == 'Evaluation'"
      >
        <v-card-text class="pa-6 d-flex justify-end">
          <v-btn
            class="white--text"
            color="#519043"
            v-if="!isEvaluating"
            @click="
              isEvaluating = true;
              bottom_actions = false;
            "
          >
            Evaluate
          </v-btn>
          <v-btn
            class="white--text mx-2"
            color="red"
            v-if="isEvaluating"
            @click="confirmSave('Cancel Evaluation')"
            >Cancel Evaluation
          </v-btn>
          <v-btn
            class="white--text"
            color="#519043"
            v-if="isEvaluating"
            @click="confirmSave('Save Evaluation')"
            >Save Evaluation
          </v-btn>

          <v-btn
            class="white--text ml-2"
            color="warning"
            v-if="!isEvaluating && ipcrER_evaluation"
            @click="confirmSave('Submit For Review')"
            >Submit For Review
          </v-btn>
        </v-card-text>
      </v-card>
      <v-card class="text-center" height="100" v-if="moduleFrom == 'Review'">
        <v-card-text class="pa-6 d-flex justify-end">
          <v-btn
            class="white--text"
            color="#519043"
            v-if="!isEvaluating"
            @click="
              isEvaluating = true;
              bottom_actions = false;
            "
          >
            Evaluate
          </v-btn>
          <v-btn
            class="white--text mx-2"
            color="red"
            v-if="isEvaluating"
            @click="confirmSave('Cancel Evaluation')"
            >Cancel Evaluation
          </v-btn>
          <v-btn
            class="white--text"
            color="#519043"
            v-if="isEvaluating"
            @click="confirmSave('Save Evaluation')"
            >Save Evaluation
          </v-btn>
          <v-btn
            class="white--text ml-2"
            v-if="!isEvaluating && ipcrER_review"
            color="warning"
            @click="confirmSave('Submit As Reviewed')"
            >Submit As Reviewed
          </v-btn>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>

    <v-dialog
      v-model="addEvalDialog"
      persistent
      eager
      scrollable
      max-width="600px"
    >
      <v-form ref="AddEvalFormRef" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header pt-2 pb-2 pl-6">
            <span>Set Evaluation</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeEvalDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-2">
            <v-container>
              <v-row>
                <v-col cols="4">
                  <v-text-field
                    outlined
                    label="Efficiency"
                    dense
                    :disabled="eval_efficiency_rated"
                    type="number"
                    v-model="eval_efficiency"
                    :rules="
                      !eval_efficiency_rated
                        ? [formRules.numberNotAboveFiveOrBelowZero]
                        : []
                    "
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    outlined
                    label="Quality"
                    dense
                    type="number"
                    :disabled="eval_quality_rated"
                    v-model="eval_quality"
                    :rules="
                      !eval_quality_rated
                        ? [formRules.numberNotAboveFiveOrBelowZero]
                        : []
                    "
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    outlined
                    label="Timeliness"
                    dense
                    :disabled="eval_timeliness_rated"
                    type="number"
                    v-model="eval_timeliness"
                    :rules="
                      !eval_timeliness_rated
                        ? [formRules.numberNotAboveFiveOrBelowZero]
                        : []
                    "
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    outlined
                    label="Remarks"
                    dense
                    v-model="eval_remarks"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>

            <v-btn color="red" outlined @click="closeEvalDialog()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>

            <v-btn
              color="#519043"
              class="white--text"
              @click="saveEval()"
              :disabled="isSubmitLoading"
              :loading="isSubmitLoading"
            >
              <v-icon>mdi-check-circle</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <WarningDialog
      :msg="warningMsg"
      v-on:yes="yes"
      v-on:no="no"
      :loading="btnLoading"
    />

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :timeout="fadeAwayMessage.timeout"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import WarningDialog from "../../Views/WarningDialog.vue";

export default {
  components: {
    WarningDialog,
  },
  props: {
    data: null,
    tbl_tab: null,
    moduleFrom: null,
  },
  data() {
    return {
      addEvalDialog: false,
      isEvaluating: false,
      bottom_actions: false,
      remarksData: [],
      confirmBtnLoading: false,
      confirmSubmitDialog: false,
      confirmDialog: false,
      itemToDelete: null,
      options: {},
      action: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        timeout: 1500,
        top: 10,
      },
      dialog: false,
      activeTab: { id: 1, name: "Core Functions" },
      tab: 1,
      tabList: [
        { id: 1, name: "Core Functions" },
        { id: 2, name: "Strategic Priority" },
        { id: 3, name: "Support Functions" },
        { id: 4, name: "Category" },
        { id: 5, name: "Evidences" },
      ],
      headers: [
        {
          text: "Month/Year",
          value: "MonthYear",
          align: "start",
          valign: "center",
        },

        {
          text: "Actions",
          value: "actions",
          align: "center",
          valign: "center",
          sortable: false,
          width: 100,
        },
      ],
      evidenceList: [],
      ipcrData: null,
      ipcrSupData: null,
      isSubmitted: null,
      targetRating: null,
      isSubmitLoading: false,
      assessed_by: null,
      assesed_by_status: null,
      final_rating_by: null,
      final_rating_by_status: null,
      id: null,
      ipcrYear: null,
      ipcrSupport: null,
      dataItem: [],
      isButtonLoading: false,
      ipcrToView: null,
      addedEvaluations: [],
      eval_efficiency: null,
      eval_quality: null,
      eval_timeliness: null,
      eval_efficiency_rated: true,
      eval_quality_rated: true,
      eval_timeliness_rated: true,
      eval_remarks: null,
      targetToEvaluate: null,
      rowIdx: null,
      sfType: null,
      warningMsg: null,
      confirmType: null,
      btnLoading: false,
      ipcrER_evaluation: null,
      ipcrER_review: null,
    };
  },

  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        console.log("IPCR data", data);
        this.isEvaluating = false;
        this.ipcrER_id = data.ipcrER_evaluation;
        this.ipcrER_review = data.ipcrER_review_id;
        this.activeTab = { id: 1, name: "Core Functions" };
        if (data.isFaculty == 1) {
          this.headers = [
            {
              text: "GDrive Link",
              value: "link",
              align: "start",
              valign: "center",
            },

            {
              text: "Actions",
              value: "actions",
              align: "center",
              valign: "center",
              sortable: false,
              width: 100,
            },
          ];
        } else {
          this.headers = [
            {
              text: "Month/Year",
              value: "MonthYear",
              align: "start",
              valign: "center",
            },

            {
              text: "Actions",
              value: "actions",
              align: "center",
              valign: "center",
              sortable: false,
              width: 100,
            },
          ];
        }
        this.ipcrYear = data.year;
        this.id = data.id;
        this.tab = 1;
        this.initialize();
      },
      deep: true,
    },
    shouldPreventRefresh: {
      deep: true,
      handler(shouldPrevent) {
        if (shouldPrevent) {
          window.addEventListener("beforeunload", this.handleBeforeUnload);
        } else {
          window.removeEventListener("beforeunload", this.handleBeforeUnload);
        }
      },
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {},

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
  computed: {
    shouldPreventRefresh() {
      return this.addedEvaluations.length > 0;
    },
    getSF1Len() {
      let len = 0;
      if (this.ipcrToView) {
        for (let i = 0; i < this.ipcrToView.data.sf1.data.length; i++) {
          if (this.ipcrToView.data.sf1.data[i].addToSF1Divisor) {
            len++;
          }
        }
      }

      return len;
    },

    getIsPendingByApprovers() {
      return this.assessed_by_status == 3 || this.final_rating_by_status == 3;
    },
    computeEvaluationCFTotal() {
      let data = this.ipcrData[0].data;
      let total = 0;
      for (let i = 0; i < data.length; i++) {
        total += !isNaN(this.computeAvg(data[i]))
          ? this.computeAvg(data[i])
          : 0;
      }

      return total;
    },

    computeEvaluationSPTotal() {
      let data = this.ipcrData[1].data;
      let total = 0;
      for (let i = 0; i < data.length; i++) {
        total += !isNaN(this.computeAvg(data[i]))
          ? this.computeAvg(data[i])
          : 0;
      }

      return total;
    },

    getSFTotalEvaluation() {
      let sf1 = 0;
      let sf2 = 0;
      let data1 = this.ipcrData ? this.ipcrData[2].data.sf1.data : [];
      let data2 = this.ipcrData ? this.ipcrData[2].data.sf2.data : [];
      let sf1DivCnt = 0;
      let sf1SubTotal = 0;
      let sf2SubTotal = 0;
      let sf1Percentage = 0.6;
      let sf2Percentage = 0.4;

      for (let i = 0; i < data1.length; i++) {
        if (data1[i].addToSF1Divisor) {
          sf1DivCnt++;
        }
        sf1SubTotal += !isNaN(this.computeAvg(data1[i]))
          ? parseFloat(this.computeAvg(data1[i]))
          : 0;
      }
      for (let i = 0; i < data2.length; i++) {
        sf2SubTotal += this.computeAvg(data2[i]);
      }

      sf1 = (sf1SubTotal / sf1DivCnt) * sf1Percentage * 0.1;
      sf2 = sf2SubTotal * sf2Percentage * 0.1;

      return {
        sf1,
        sf2,
      };
    },

    computeReviewCFTotal() {
      let data = this.ipcrData[0].data;
      let total = 0;
      for (let i = 0; i < data.length; i++) {
        if (data[i].hasReview) {
          total += !isNaN(this.computeReviewAvg(data[i]))
            ? this.computeReviewAvg(data[i])
            : 0;
        } else {
          total += !isNaN(this.computeAvg(data[i]))
            ? this.computeAvg(data[i])
            : 0;
        }
      }

      return total;
    },

    computeReviewSPTotal() {
      let data = this.ipcrData[1].data;
      let total = 0;
      for (let i = 0; i < data.length; i++) {
        if (data[i].hasReview) {
          total += !isNaN(this.computeReviewAvg(data[i]))
            ? this.computeReviewAvg(data[i])
            : 0;
        } else {
          total += !isNaN(this.computeAvg(data[i]))
            ? this.computeAvg(data[i])
            : 0;
        }
      }

      return total;
    },

    getSFTotalReview() {
      let sf1 = 0;
      let sf2 = 0;
      let data1 = this.ipcrData ? this.ipcrData[2].data.sf1.data : [];
      let data2 = this.ipcrData ? this.ipcrData[2].data.sf2.data : [];
      let sf1DivCnt = 0;
      let sf1SubTotal = 0;
      let sf2SubTotal = 0;
      let sf1Percentage = 0.6;
      let sf2Percentage = 0.4;

      for (let i = 0; i < data1.length; i++) {
        if (data1[i].addToSF1Divisor) {
          sf1DivCnt++;
        }
        if (data1[i].hasReview) {
          sf1SubTotal += !isNaN(this.computeReviewAvg(data1[i]))
            ? parseFloat(this.computeReviewAvg(data1[i]))
            : 0;
        } else {
          sf1SubTotal += !isNaN(this.computeAvg(data1[i]))
            ? parseFloat(this.computeAvg(data1[i]))
            : 0;
        }
      }
      for (let i = 0; i < data2.length; i++) {
        console.log("DATA 2", data2[i]);
        if (data2[i].hasReview) {
          sf2SubTotal += this.computeReviewAvg(data2[i]);
        } else {
          sf2SubTotal += this.computeAvg(data2[i]);
        }
      }

      sf1 = (sf1SubTotal / sf1DivCnt) * sf1Percentage * 0.1;
      sf2 = sf2SubTotal * sf2Percentage * 0.1;

      return {
        sf1,
        sf2,
      };
    },

    getEvaluationGenAvg() {
      let cfP = this.ipcrData[0].data.length > 0 ? 0.6 : 0.9;
      let spP = this.ipcrData[1].data.length > 0 ? 0.3 : 0;
      let sfP = 0.1;

      let cfAvg =
        (this.computeEvaluationCFTotal / this.ipcrData[0].data.length) * cfP;
      let spAvg =
        (this.computeEvaluationSPTotal / this.ipcrData[1].data.length) * spP;
      let sfAvg =
        (this.getSFTotalEvaluation.sf1 + this.getSFTotalEvaluation.sf2) * sfP;
      return {
        cfAvg,
        spAvg,
        sfAvg,
      };
    },

    getReviewGenAvg() {
      let cfP = this.ipcrData[0].data.length > 0 ? 0.6 : 0.9;
      let spP = this.ipcrData[1].data.length > 0 ? 0.3 : 0;
      let sfP = 0.1;

      let cfAvg =
        (this.computeReviewCFTotal / this.ipcrData[0].data.length) * cfP;
      let spAvg =
        (this.computeReviewSPTotal / this.ipcrData[1].data.length) * spP;
      let sfAvg = (this.getSFTotalReview.sf1 + this.getSFTotalReview.sf2) * sfP;
      return {
        cfAvg,
        spAvg,
        sfAvg,
      };
    },

    getFinalAvgRating() {
      let evalT = this.formatNumberValue(
        parseFloat(this.formatNumberValue(this.getEvaluationGenAvg.cfAvg, 2)) +
          parseFloat(
            this.formatNumberValue(this.getEvaluationGenAvg.spAvg, 2)
          ) +
          parseFloat(this.formatNumberValue(this.getEvaluationGenAvg.sfAvg, 2)),
        2
      );
      let reviewT = this.formatNumberValue(
        parseFloat(this.formatNumberValue(this.getReviewGenAvg.cfAvg, 2)) +
          parseFloat(this.formatNumberValue(this.getReviewGenAvg.spAvg, 2)) +
          parseFloat(this.formatNumberValue(this.getReviewGenAvg.sfAvg, 2)),
        2
      );

      let evalRating = this.getRating(evalT);
      let reviewRating = this.getRating(evalT);

      return {
        evaluation: {
          total: evalT,
          adjectival_rating: evalRating,
        },
        review: {
          total: reviewT,
          adjectival_rating: reviewRating,
        },
      };
    },
  },

  methods: {
    handleBeforeUnload(e) {
      e.preventDefault();
      e.returnValue = "";
      return "";
    },

    getRating(t) {
      let finalAvgRating = "";
      if (t >= 5) {
        finalAvgRating = "Outstanding";
      } else if (t <= 4.9 && t >= 4.0) {
        finalAvgRating = "Very Satisfactory";
      } else if (t <= 3.9 && t >= 3.0) {
        finalAvgRating = "Satisfactory";
      } else if (t <= 2.9 && t >= 3.0) {
        finalAvgRating = "Unsatisfactory";
      } else {
        finalAvgRating = "Poor";
      }
      return finalAvgRating;
    },

    getAddEvaluationBtnText(item) {
      if (this.moduleFrom == "Review") {
        return item.hasReview ? "Edit" : "Add";
      } else {
        return item.hasEvaluation ? "Edit" : "Add";
      }
    },
    initialize() {
      this.loading = true;
      if (this.id && this.tab) {
        this.axiosCall("/ipcr/getIPCRForEvaluationById/" + this.id, "GET").then(
          (res) => {
            if (res) {
              this.ipcrER_evaluation = res.data.hasEvaluationData
                ? res.data.hasEvaluationData.id
                : null;
              console.log("IPCR FOR EVALUATION", res.data);
              this.ipcrData = res.data.ipcr;
              this.evidenceList = res.data.evidences;
              if (this.tab != 5) {
                this.ipcrToView = res.data.ipcr[this.tab - 1];
              }
              this.loading = false;
            }
          }
        );
      }
    },

    computeGeneralAve(data, percentage) {
      let avg = 0;
      if (percentage != 0) {
        if (data.data.length) {
          avg = ((data.total / data.data.length) * percentage).toFixed(2);
        } else {
          avg = (data.total * percentage).toFixed(2);
        }
        return avg;
      } else {
        return 0.0;
      }
    },
    getOverAllrating() {
      let total = 0;
      for (let i = 0; i < this.ipcrData.length; i++) {
        let d = this.computeGeneralAve(
          this.ipcrData[i],
          this.ipcrData[i].func_type != "Support Function"
            ? this.ipcrData[i].func_type == "Core Function"
              ? this.ipcrData[1].data.length > 0
                ? 0.6
                : 0.9
              : this.ipcrData[1].data.length > 0
              ? 0.3
              : 0
            : 0.1
        );
        total += parseFloat(d);
      }
      return total.toFixed(2);
    },

    closeEvalDialog() {
      this.targetToEvaluate = null;
      this.rowIdx = null;
      this.addEvalDialog = false;
    },

    computeAvg(item) {
      let divisor = 0;
      let e = 0;
      let q = 0;
      let t = 0;
      if (item.hasEvaluation) {
        if (item.e_avg != "NR") {
          if (item.evaluation.efficiency) {
            e = parseFloat(item.evaluation.efficiency);
          } else {
            e = parseFloat(item.e_avg);
          }
          divisor++;
        }
        if (item.q_avg != "NR") {
          if (item.evaluation.quality) {
            q = parseFloat(item.evaluation.quality);
          } else {
            q = parseFloat(item.q_avg);
          }
          divisor++;
        }
        if (item.t_avg != "NR") {
          if (item.evaluation.timeliness) {
            t = parseFloat(item.evaluation.timeliness);
          } else {
            t = parseFloat(item.t_avg);
          }
          divisor++;
        }
      } else {
        if (item.e_avg != "NR") {
          e = parseFloat(item.e_avg);
          divisor++;
        }
        if (item.q_avg != "NR") {
          q = parseFloat(item.q_avg);
          divisor++;
        }
        if (item.t_avg != "NR") {
          t = parseFloat(item.t_avg);
          divisor++;
        }
      }

      return (e + q + t) / divisor;
    },

    computeReviewAvg(item, prct) {
      let divisor = 0;
      let e = 0;
      let q = 0;
      let t = 0;

      console.log("item", item);
      if (item) {
        if (item.hasReview) {
          if (item.e_avg != "NR") {
            if (item.review.efficiency) {
              e = parseFloat(item.review.efficiency);
            } else {
              if (item.evaluation.efficiency) {
                e = parseFloat(item.evaluation.efficiency);
              } else {
                e = parseFloat(item.e_avg);
              }
            }

            divisor++;
          }
          if (item.q_avg != "NR") {
            if (item.review.quality) {
              q = parseFloat(item.review.quality);
            } else {
              if (item.evaluation.quality) {
                q = parseFloat(item.evaluation.quality);
              } else {
                q = parseFloat(item.q_avg);
              }
            }
            divisor++;
          }
          if (item.t_avg != "NR") {
            if (item.review.timeliness) {
              t = parseFloat(item.review.timeliness);
            } else {
              if (item.evaluation.timeliness) {
                t = parseFloat(item.evaluation.timeliness);
              } else {
                t = parseFloat(item.t_avg);
              }
            }
            divisor++;
          }
        } else {
          if (item.hasEvaluation) {
            if (item.e_avg != "NR") {
              if (item.evaluation.efficiency) {
                e = parseFloat(item.evaluation.efficiency);
              } else {
                e = parseFloat(item.e_avg);
              }
              divisor++;
            }
            if (item.q_avg != "NR") {
              if (item.evaluation.efficiency) {
                q = parseFloat(item.evaluation.quality);
              } else {
                q = parseFloat(item.q_avg);
              }

              divisor++;
            }
            if (item.t_avg != "NR") {
              if (item.evaluation.efficiency) {
                t = parseFloat(item.evaluation.timeliness);
              } else {
                t = parseFloat(item.t_avg);
              }
              divisor++;
            }
          } else {
            if (item.e_avg != "NR") {
              e = parseFloat(item.e_avg);
              divisor++;
            }
            if (item.q_avg != "NR") {
              q = parseFloat(item.q_avg);
              divisor++;
            }
            if (item.t_avg != "NR") {
              t = parseFloat(item.t_avg);
              divisor++;
            }
          }
        }
        if (prct) {
          return ((e + q + t) / divisor) * parseFloat(prct);
        }
      }

      return (e + q + t) / divisor;
    },

    closeD() {
      if (this.shouldPreventRefresh) {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.timeout = 5000;
        this.fadeAwayMessage.message =
          "You have unsaved changes, please click the ACTIONS button below to show save button.";
      } else {
        this.eventHub.$emit("closeCECDialog", false);
        this.confirmSubmitDialog = false;
        this.confirmBtnLoading = false;
        this.isSubmitLoading = false;
        this.dialog = false;
      }
    },
    add_evaluation(item, index, sfType) {
      console.log("ITEMS", item);
      this.eval_efficiency_rated = item.e_avg == "NR";
      this.eval_quality_rated = item.q_avg == "NR";
      this.eval_timeliness_rated = item.t_avg == "NR";
      this.sfType = sfType;
      if (this.moduleFrom == "Review") {
        if (item.review) {
          this.eval_efficiency = item.review.efficiency;
          this.eval_quality = item.review.quality;
          this.eval_timeliness = item.review.timeliness;
          this.eval_remarks = item.review.remarks;
        } else {
          this.eval_efficiency = null;
          this.eval_quality = null;
          this.eval_timeliness = null;
          this.eval_remarks = null;
        }
      } else {
        if (item.evaluation) {
          this.eval_efficiency = item.evaluation.efficiency;
          this.eval_quality = item.evaluation.quality;
          this.eval_timeliness = item.evaluation.timeliness;
          this.eval_remarks = item.evaluation.remarks;
        } else {
          this.eval_efficiency = null;
          this.eval_quality = null;
          this.eval_timeliness = null;
          this.eval_remarks = null;
        }
      }

      this.rowIdx = index;
      this.targetToEvaluate = item;
      this.$refs.AddEvalFormRef.resetValidation();
      this.addEvalDialog = true;
    },

    saveEval() {
      console.log("saveEval");
      if (this.$refs.AddEvalFormRef.validate()) {
        let trgt_type =
          this.tab == 1
            ? "Core Function"
            : this.tab == 2
            ? "Strategic Priority"
            : this.tab == 3
            ? "Support Function"
            : "";
        let data = {
          efficiency: this.eval_efficiency,
          quality: this.eval_quality,
          timeliness: this.eval_timeliness,
          remarks: this.eval_remarks,
          trgt_type: trgt_type,
          trgt_id:
            this.tab != 3
              ? this.targetToEvaluate.ipcrTargetId
              : this.targetToEvaluate.supportId
              ? this.targetToEvaluate.supportId
              : null,
        };
        this.addedEvaluations.push(data);
        this.insertEvaluation(data);
        this.closeEvalDialog();
      }
    },

    insertEvaluation(data) {
      if (this.moduleFrom == "Review") {
        if (this.tab == 1) {
          this.ipcrData[0].data[this.rowIdx].hasReview = true;
          this.ipcrData[0].data[this.rowIdx].review = data;
        }
        if (this.tab == 2) {
          this.ipcrData[1].data[this.rowIdx].hasReview = true;
          this.ipcrData[1].data[this.rowIdx].review = data;
        }
        if (this.tab == 3) {
          if (this.sfType == "sf1") {
            this.ipcrData[2].data.sf1.data[this.rowIdx].hasReview = true;
            this.ipcrData[2].data.sf1.data[this.rowIdx].review = data;
          }
          if (this.sfType == "sf2") {
            console.log("CALLED HEERE");
            this.ipcrData[2].data.sf2.data[this.rowIdx].hasReview = true;
            this.ipcrData[2].data.sf2.data[this.rowIdx].review = data;
          }
        }
      } else {
        if (this.tab == 1) {
          this.ipcrData[0].data[this.rowIdx].hasEvaluation = true;
          this.ipcrData[0].data[this.rowIdx].evaluation = data;
        }
        if (this.tab == 2) {
          this.ipcrData[1].data[this.rowIdx].hasEvaluation = true;
          this.ipcrData[1].data[this.rowIdx].evaluation = data;
        }
        if (this.tab == 3) {
          if (this.sfType == "sf1") {
            this.ipcrData[2].data.sf1.data[this.rowIdx].hasEvaluation = true;
            this.ipcrData[2].data.sf1.data[this.rowIdx].evaluation = data;
          }
          if (this.sfType == "sf2") {
            this.ipcrData[2].data.sf2.data[this.rowIdx].hasEvaluation = true;
            this.ipcrData[2].data.sf2.data[this.rowIdx].evaluation = data;
          }
        }
      }
    },

    saveEvaluation() {
      if (this.addedEvaluations.length > 0) {
        let data = {
          ipcrID: this.id,
          evaluations: JSON.stringify(this.addedEvaluations),
        };
        let url =
          this.moduleFrom == "Review"
            ? "/ipcr/saveAddedReviews"
            : "/ipcr/saveAddedEvaluations";
        this.axiosCall(url, "POST", data).then((res) => {
          if (res.data.status == 201) {
            this.warningMsg = null;
            this.addedEvaluations = [];
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.isEvaluating = false;
            this.initialize();
          } else {
            this.warningMsg = null;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      } else {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = "No added evaluations yet!";
      }
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      if (this.tab != 5) {
        this.ipcrToView = this.ipcrData[this.tab - 1];
      }
      //   this.initialize();
    },

    yes() {
      this.btnLoading = true;

      if (this.confirmType == "Save Evaluation") {
        this.saveEvaluation();
      }
      if (this.confirmType == "Submit For Review") {
        this.saveForReview();
      }
      if (this.confirmType == "Submit As Reviewed") {
        this.saveAsReviewed();
      }
      if (this.confirmType == "Cancel Evaluation") {
        this.cancelEvaluation();
      }
    },
    no() {
      this.warningMsg = null;
      this.confirmType = null;
    },

    cancelEvaluation() {
      this.isEvaluating = false;
      this.addedEvaluations = [];

      this.warningMsg = null;
      this.fadeAwayMessage.show = true;
      this.fadeAwayMessage.type = "success";
      this.fadeAwayMessage.header = "System Message";
      this.fadeAwayMessage.message = "Cancelled successfully!";
      this.initialize();
    },

    saveForReview() {
      this.bottom_actions = false;

      this.axiosCall(
        "/ipcr/submitEvaluation/" + this.ipcrER_evaluation,
        "PATCH"
      ).then((res) => {
        if (res.data.status == 200) {
          this.warningMsg = null;
          this.addedEvaluations = [];
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.closeD();
        } else {
          this.warningMsg = null;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
        }
      });
    },

    saveAsReviewed() {
      this.bottom_actions = false;

      this.axiosCall("/ipcr/submitReviewed/" + this.id, "PATCH").then((res) => {
        if (res.data.status == 200) {
          this.warningMsg = null;
          this.addedEvaluations = [];
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.closeD();
        } else {
          this.warningMsg = null;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
        }
      });
    },

    confirmSave(type) {
      this.confirmType = type;

      if (type == "Save Evaluation") {
        this.btnLoading = true;
        this.warningMsg = "Are you sure you want to save added evaluations?";
      }

      if (type == "Submit For Review") {
        this.warningMsg =
          "Are you sure you want to submit this IPCR for REVIEW?";
      }

      if (type == "Submit As Reviewed") {
        this.warningMsg =
          "Are you sure you want to submit this IPCR as REVIEWED?";
      }

      if (type == "Cancel Evaluation") {
        if (this.addedEvaluations.length > 0) {
          this.warningMsg =
            "You have unsaved evaluations, Are you sure you want to CANCEL this?";
        } else {
          this.isEvaluating = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = "Cancelled successfully!";
        }
      }
    },

    // confirmDelete() {
    //   this.isButtonLoading = true;
    //   let url;
    //   if (this.tab == 3) {
    //     url = "/ipcr-support/deleteMySupport/" + this.itemToDelete.id;
    //   } else {
    //     url = "/ipcr-target/deleteTarget/" + this.itemToDelete.id;
    //   }

    //   this.axiosCall(url, "DELETE").then((res) => {
    //     if (res.data.status == 200) {
    //       this.confirmDialog = false;
    //       this.fadeAwayMessage.show = true;
    //       this.fadeAwayMessage.type = "success";
    //       this.fadeAwayMessage.header = "System Message";
    //       this.fadeAwayMessage.message = res.data.msg;
    //       this.isButtonLoading = false;
    //       this.itemToDelete = null;
    //       this.confirmDialog = false;

    //       this.initialize();
    //     } else {
    //       this.fadeAwayMessage.show = true;
    //       this.fadeAwayMessage.type = "error";
    //       this.fadeAwayMessage.header = "System Message";
    //       this.fadeAwayMessage.message = res.data.msg;
    //       this.isButtonLoading = false;
    //     }
    //   });
    // },

    getUsers() {
      this.axiosCall("/user-details/getAllUserDetail", "GET").then((res) => {
        this.users = res.data;
        // console.log(res.data);
      });
    },

    viewAttachment(item) {
      let url =
        process.env.VUE_APP_SERVER +
        "/ipcr-target/previewFile/" +
        item.filename;

      let token = localStorage.getItem("token");
      const tab = window.open("about:blank");
      // this.isLoading = true;
      fetch(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => response.blob())
        .then((blob) => {
          var _url = window.URL.createObjectURL(blob);

          tab.location = _url;
          tab.focus();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    viewMPOR(item) {
      let url =
        process.env.VUE_APP_SERVER +
        "/pdf-generator/generateIPCRForm/MPOR/" +
        item.ipcr_ID +
        "?month=" +
        item.month;

      let token = localStorage.getItem("token");
      const tab = window.open("about:blank");
      // this.isLoading = true;
      fetch(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => response.blob())
        .then((blob) => {
          var _url = window.URL.createObjectURL(blob);

          tab.location = _url;
          tab.focus();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getUserName(id) {
      if (this.users.length > 0) {
        let idx = this.users.findIndex((u) => u.id == id);
        return this.toTitleCase(this.users[idx].name);
      }
      return;
    },
  },
};
</script>

<style scoped>
.preserve-whitespace {
  white-space: pre-line;
  word-wrap: break-word;
}

#ipcrTable,
#categoryTable {
  width: 100%;
  border-collapse: collapse;
}
#ipcrTable td,
#ipcrTable th,
#categoryTable td,
#categoryTable th {
  border: 1px solid grey;
}
</style>
